export enum FILTER_BY {
  FO = "FO",
  AREA = "AREA",
  CITY = "CITY",
  DEALER = "DEALER",
  COUNTRY = "COUNTRY",
}

export const filterByArr = [
  {
    label: "по дилеру",
    labelEn: "by dealer",
    value: FILTER_BY.DEALER,
  },
  {
    label: "по стране",
    labelEn: "by country",
    value: FILTER_BY.COUNTRY,
  },
  {
    label: "по федеральному округу",
    labelEn: "by federal area",
    value: FILTER_BY.FO,
  },
  {
    label: "по области",
    labelEn: "by subject",
    value: FILTER_BY.AREA,
  },
  {
    label: "по городу",
    labelEn: "by city",
    value: FILTER_BY.CITY,
  },
];

export const itemsDataRoute = (isEn) =>
  `data.DealerGetter.getDealersLocationItem.${isEn ? "itemsEn" : "items"}`;

export const resolveDropList = (
  option: FILTER_BY,
  listOpDrops: { [key: string]: any }
) => listOpDrops[option];
